import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditHoliday = () => {
    const { id } = useParams(); // Extract the holiday ID from the URL
    const [name, setName] = useState('');
    const [date, setDate] = useState('');
    const navigate = useNavigate();

    // Fetch the holiday data when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}holidays/${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setName(data.data.name);
                    // Format the date to YYYY-MM-DD format
                    const formattedDate = new Date(data.data.date).toISOString().split('T')[0];
                    setDate(formattedDate);
                } else {
                    alert('Holiday not found.');
                }
            })
            .catch((error) => console.error('Error fetching holiday:', error));
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        const updatedHoliday = {
            name,
            date,
        };

        fetch(`${BASE_URL}holidays/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedHoliday),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    // Navigate back to the holidays list page after successful update
                    alert('Holiday updated successfully!');
                    navigate('/HolidaysList'); // Redirect to holidays list page
                } else {
                    alert('Error updating holiday. Please try again.');
                }
            })
            .catch((error) => console.error('Error updating holiday:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Holiday</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                    {/* You can add breadcrumb items if needed */}
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Holiday Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Holiday Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Holiday Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            placeholder="Enter holiday name"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="date" className="form-label">Holiday Date</label>
                                        <input
                                            type="date"
                                            id="date"
                                            className="form-control"
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Holiday</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Edit Holiday Form */}
        </div>
    );
};

export default EditHoliday;
